import { StoreFrontScriptManagerContext } from '../context'
import ScriptsHeader from '../sections/headers/ScriptsHeader'
import ScriptsTable from '../sections/tables/ScriptsTable'
import useGetScriptsList from '../hooks/useGetScriptsList'
import useScriptOperations from '../hooks/useScriptOperations'
import { Pagination } from '../../../utils/pagination'
import usePermission from '../../../hook/usePermission'

export default function Scripts() {
  const {scriptsList, pagination, isLoading, filters, onSearch, onPageChange, onSortingChange} =
    useGetScriptsList()

  const {deleteScript, isOperationLoading} = useScriptOperations()
  const {hasPermission} = usePermission()
  const hasWritePermission = hasPermission('storefronts_script manager', 'write')

  const contextValue = {
    scriptList: scriptsList,
    isLoading,
    isOperationLoading,
    filters,
    pagination,
    deleteScript,
    onSearch,
    onPageChange,
    onSortingChange,
    hasWritePermission,
  }

  return (
    <StoreFrontScriptManagerContext.Provider value={contextValue}>
      <ScriptsHeader />
      <ScriptsTable />
      <Pagination onPageChange={onPageChange} pagination={pagination} />
    </StoreFrontScriptManagerContext.Provider>
  )
}
